// extracted by mini-css-extract-plugin
export default {"container":"RedirectLinks_container__Hg5aQ","item":"RedirectLinks_item__3NFI5","link":"RedirectLinks_link__TSWY2"};